import {ApplicationSigningState} from "@/api-client";
import {ls} from "@/CultureService";

export default function translateApplicationSigningState(state: ApplicationSigningState): string {
    switch (state) {
        case ApplicationSigningState.NotSigned:
            return ls.Applications_Table_Filter_Option_SigningState_NotSigned
        case ApplicationSigningState.ForwardedToSigning:
            return ls.Applications_Table_Filter_Option_SigningState_ForwardedToSigning
        case ApplicationSigningState.Signed:
            return ls.Applications_Table_Filter_Option_SigningState_Signed
        default:
            return state;
    }
}